// extracted by mini-css-extract-plugin
export default {"mainContent":"WithdrawalHistory_mainContent__Q0r+q"};